import { AfterViewInit, Component, OnDestroy } from '@angular/core';

declare global {
  interface Window {
    $aivo?: any;
    __aivoBootstrapped?: boolean;
  }
}

@Component({
  selector: 'tech-eva-chat',
  templateUrl: './eva-chat.component.html',
  styleUrls: ['./eva-chat.component.scss'],
})
export class EvaChatComponent implements AfterViewInit, OnDestroy {
  private readonly botId = 'a9db33ca9006b98c067bdd3a3721e3ff';
  private readonly coreScriptId = '_agentCoreScript';

  ngAfterViewInit(): void {
    this.ensureCompatibilityPolyfills();
    this.bootstrapEva();
  }

  ngOnDestroy(): void {
    this.cleanupEvaArtifacts();
  }

  private ensureCompatibilityPolyfills(): void {
    (window as any).global = (window as any).global || window;
    (window as any).process = (window as any).process || {
      env: { DEBUG: undefined },
      version: '',
    };

    // Some CobrowseIO builds expose function-like objects and expect `.on`.
    const functionProto = Function.prototype as any;
    if (typeof functionProto.on !== 'function') {
      Object.defineProperty(functionProto, 'on', {
        configurable: true,
        writable: true,
        enumerable: false,
        value: function () {
          return this;
        },
      });
    }
  }

  private bootstrapEva(): void {
    if (window.__aivoBootstrapped) {
      return;
    }

    (function (b: any) {
      const g = '$aivo';
      let h = !!window.$aivo && window.$aivo;

      b[g] = b[g] || {
        next: null,
        init: function (j: string) {
          const p = document.getElementsByTagName('head')[0];
          const q = document.createElement('script') as HTMLScriptElement;
          const u = '_agentCoreScript';
          const w = window as any;

          q.onload = q.onerror = function () {
            if ((h = w[g]), h) {
              w[g] = h;
            } else {
              try {
                delete w[g];
              } catch (x) {
                w[g] = void 0;
              }
            }

            b[g] = h;
            setTimeout(function () {
              window.$aivo.run(j, window.$aivo.__next);
            }, 1);
          };

          const currentCore = document.getElementById(u);
          if (currentCore && currentCore.parentNode) {
            currentCore.parentNode.removeChild(currentCore);
          }

          q.async = true;
          q.id = u;
          q.src = 'https://cdn.agentbot.net/core/latest/core.js';
          q.charset = 'UTF-8';
          p.parentNode.insertBefore(q, p);
        },
        ready: function (j: unknown) {
          window.$aivo.__next = j;
        },
      };
    })(window as any);

    window.__aivoBootstrapped = true;
    window.$aivo.init(this.botId);
  }

  private cleanupEvaArtifacts(): void {
    const coreScript = document.getElementById(this.coreScriptId);
    if (coreScript && coreScript.parentNode) {
      coreScript.parentNode.removeChild(coreScript);
    }

    document.body.classList.remove('AgentBot', 'agentbot');

    const possibleWidgets = document.querySelectorAll(
      'iframe[src*="agentbot.net"], iframe[src*="aivo"], .agentbot, .AgentBot, [id*="agentbot"]'
    );

    possibleWidgets.forEach((node) => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
      }
    });

    try {
      delete (window as any).$aivo;
    } catch {
      (window as any).$aivo = undefined;
    }

    window.__aivoBootstrapped = false;
  }
}
